// extracted by mini-css-extract-plugin
export default {"form":"ProfileForm_form__zc6aw","control":"ProfileForm_control__fqOxM"};